let sdkLoaded = false;
let sdkLoading = false;
let pendingCallbacks = [];

function onSdkReady() {
   sdkLoaded = true;
   sdkLoading = false;
   pendingCallbacks.forEach(cb => cb());
   pendingCallbacks = [];
}

export function loadAppleSdk(callback) {
   if (sdkLoaded) {
      callback();
      return;
   }

   pendingCallbacks.push(callback);

   if (sdkLoading) {
      return; // Script is loading, callback will be called when ready
   }

   sdkLoading = true;

   const script = document.createElement('script');
   script.src =
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
   script.async = true;
   script.onload = () => {
      // In popup mode, redirectURI is validated but not used for actual redirects.
      // Must match exactly what's registered in Apple Developer Console.
      window.AppleID.auth.init({
         clientId: App.appleClientId,
         scope: 'name email',
         redirectURI: window.location.origin + '/Guide/User/remote_login',
         usePopup: true,
      });
      onSdkReady();
   };
   script.onerror = () => {
      sdkLoading = false;
      console.error('Failed to load Apple Sign In SDK');
   };
   document.body.append(script);
}
